import {
  ContextOverrides,
  SubjectKeyTypes,
  useGetEppoAssignment,
  VariationTypes,
} from '@vimeo/eppo';
import { useViewer, Viewer } from '@vimeo/viewer';

/**
 * Hook to determine if a logged-in user should be bucketed into an upsell modal-related test
 */
const shouldShowUpsellModal = (
  upsellDescription: string,
  viewer: Viewer,
  getEppoAssignment: unknown,
  flagKey: string,
  bigPictureOverrides?: ContextOverrides,
  additionalData?: Record<string, unknown>,
) => {
  const userId = viewer?.user?.id || 0;

  if (typeof getEppoAssignment === 'function') {
    const { assignment } = getEppoAssignment({
      flagKey,
      subject: {
        key: userId,
        keyType: SubjectKeyTypes.CUID,
        additionalData: {
          upsell_description: upsellDescription,
          ...additionalData,
        },
      },
      bigPictureOverrides: bigPictureOverrides,
      assignmentType: VariationTypes.BOOLEAN,
      defaultAssignment: false,
    });
    return assignment;
  }

  return false;
};

export const useUpsellModalFlag = () => {
  const viewer = useViewer();
  const { getEppoAssignment } = useGetEppoAssignment();
  return {
    getShouldShowUpsellModal: (
      upsellDescription: string,
      flagKey: string,
      bigPictureOverrides?: ContextOverrides,
      additionalData?: Record<string, unknown>,
    ) =>
      shouldShowUpsellModal(
        upsellDescription,
        viewer,
        getEppoAssignment,
        flagKey,
        bigPictureOverrides,
        additionalData,
      ),
  };
};
